import * as z from "zod/v4";

export const cancelFreightBooking = {
  name: "cancelFreightBooking" as const,
  input: z.object({ fulfillmentGroupId: z.string() }),
  output: z.object({}),
};
